import { Component, inject, OnInit } from '@angular/core';
import { FieldBuilder } from '../../../services/fields/field-builder';
import { IField } from '../../../model/i-field';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { WindowField } from '../../../dialogs/window-field/window-field';

@Component({
  selector: 'app-mobile-field',
  imports: [],
  templateUrl: './mobile-field.html',
  styleUrl: './mobile-field.scss'
})
export class MobileField implements OnInit{
  fieldBuilder = inject(FieldBuilder);
  readonly dialog = inject(MatDialog);

  fields: IField[] = this.fieldBuilder.listFields;

  ngOnInit() { 
    this.fields = this.fieldBuilder.listFields;    
  }

  addOpacity(color: string):string{
    return color + 33;
  }

  styleField(position: number, stl: string){
    let style: Array<string> = ["default"];
    style.push(stl);
    return style.join(" ");
  }

  showInfoField(field: IField){
    const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'nutri-templs';
        dialogConfig.backdropClass = 'nutri-templs-backdrop';
        dialogConfig.data = {
          field
        }
        const dialogRef = this.dialog.open(WindowField, dialogConfig);
  }

}
